import Descriptions from 'antd/lib/descriptions';
import Modal from 'antd/lib/modal/Modal';
import Spin from 'antd/lib/spin';
import { useSiteRapQuery } from '../../domain/site-rap/queries';
import { ISite } from '../../domain/site/interface';
import { SITE_STATUS_TEXT_MAP } from '../../pages/sites/siteInterface';

interface IViewRapInfoModalProps {
    site: ISite;
    onClose: () => void;
}

export const ViewRapInfoModal: React.FC<IViewRapInfoModalProps> = ({ site, onClose }) => {
    const { data: siteRap, isLoading, isFetching } = useSiteRapQuery(site.site_id);

    const content = () => {
        return (
            <Spin tip="Loading..." spinning={isLoading || isFetching}>
                <Descriptions bordered colon size="small" column={1}>
                    <Descriptions.Item label="Site ID">{site.site_id}</Descriptions.Item>
                    <Descriptions.Item label="Site Name">{site.site_name}</Descriptions.Item>
                    <Descriptions.Item label="Site Address">{site.site_address}</Descriptions.Item>
                    <Descriptions.Item label="Site Status">{SITE_STATUS_TEXT_MAP[site.status] || '-'}</Descriptions.Item>

                    <Descriptions.Item label="Participation Type">{siteRap?.configuration?.participation_type || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Reduction Type">{siteRap?.configuration?.reduction_type || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Primary Load Type">{siteRap?.configuration?.primary_load_type || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Curtailment Strategy">
                        {siteRap?.configuration?.curtailment_strategy?.split(';').join(', ') || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Reduction Action Plan">
                        <div style={{ whiteSpace: 'pre-wrap', maxHeight: '200px', overflow: 'auto' }}>
                            {siteRap?.configuration?.reduction_action_plan || '-'}
                        </div>
                    </Descriptions.Item>
                    <Descriptions.Item label="Data Source">{siteRap?.source || '-'}</Descriptions.Item>
                </Descriptions>
            </Spin>
        );
    };

    return (
        <Modal open width={800} title="RAP Information" destroyOnHidden onCancel={onClose} footer={[]}>
            {content()}
        </Modal>
    );
};
